import { useQuery } from "@tanstack/react-query"
import { trpcClient } from "@tokenterminal/core/utils/trpc"

export const useMarketSectorsList = () => {
  return useQuery({
    queryKey: ["market-sectors-list"],
    queryFn: async () => {
      const result = await trpcClient.marketSectors.getMarketSectors.query()
      return result.data
    },
    staleTime: 1000 * 60 * 10,
  })
}
